<template>
  <div id="app">
    <Header class="sticky top-0 z-50" />

    <main class="relative">
      <router-view />
    </main>
  </div>
</template>

<script>
import Header from "./components/Header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
};
</script>

<style>
h1 {
  font-size: 3.75rem;
  font-weight: 600;
  line-height: 1;
  padding-bottom: 1rem;
  font-family: serif;
}

h2 {
  font-size: 2.5rem;
  font-weight: 600;
  /* font-family: serif; */
}

h3 {
  font-size: 2rem;
}

@media (max-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.5rem;
  }
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
html,
body {
  overscroll-behavior: none;
}

/* html {
    overflow: hidden;
    height: 100%;
}

body {
    overflow: auto;
    height: 100%;
} */
</style>
